<button type="button" class="org-picker-btn" [class.narrowed]="!allSelected"
        [matMenuTriggerFor]="orgMenu"
        [attr.aria-label]="'Show notes from: ' + notes.orgScopeLabel"
        matTooltip="Choose which organisations' notes to show">
  <mat-icon aria-hidden="true">business</mat-icon>
  <span class="org-picker-label">{{ notes.orgScopeLabel }}</span>
  <mat-icon aria-hidden="true">expand_more</mat-icon>
</button>

<!-- Unread notes hidden by the selection, so narrowing never silently hides something new. -->
<span *ngIf="!allSelected && hiddenUnread() as n" class="org-picker-hidden"
      matTooltip="Unread notes in organisations that are not ticked">
  {{ n }} unread hidden
</span>

<mat-menu #orgMenu="matMenu" class="bc-shell-menu note-org-menu" xPosition="before">
  <!-- Clicks inside keep the menu open, so several organisations can be ticked in one go. -->
  <div class="org-menu" role="group" aria-label="Organisations" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
    <label class="org-row org-row--all">
      <input #allBox type="checkbox" [checked]="allSelected" (change)="toggleAll(allBox)" />
      <span class="org-name">All organisations</span>
    </label>

    <div class="org-divider" role="separator"></div>

    <p *ngIf="notes.noOrgSelected" class="org-hint">Tick the organisations whose notes you want to see.</p>

    <div class="org-row" *ngFor="let org of notes.orgOptions; trackBy: trackOrg">
      <label class="org-check">
        <input #orgBox type="checkbox" [checked]="notes.isOrgSelected(org.id)" (change)="toggle(org.id, orgBox)" />
        <span class="org-name">
          {{ org.name }}<span *ngIf="org.current" class="org-tag"> (this tab)</span>
        </span>
        <span *ngIf="org.unread" class="org-unread" [attr.aria-label]="org.unread + ' unread'">{{ org.unread }}</span>
        <span *ngIf="org.count" class="org-count">{{ org.count }}</span>
      </label>
      <button type="button" class="org-only" (click)="only(org.id)"
              [attr.aria-label]="'Show only ' + org.name">Only</button>
    </div>
  </div>
</mat-menu>
